import React, { ReactNode, useEffect, useState } from 'react'
import LoadingSpinner from '../../ui/LoadingSpinner';
import { Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import LabelText from '../../ui/LabelText';
import { clubSortableKeys, IClubComparisonData } from '../../types/ClubComparison';
import SortArrowDescIcon from '../../assets/icons/sortdown.svg'
import SortArrowAscIcon from '../../assets/icons/sortup.svg'
import { useLoading } from '../../contexts/LoadingContext';
import SecondaryButton from '../../ui/SecondaryButton';
import LabelNumber from '../../styled-components/LabelNumber';
import CustomizedTooltips from '../../ui/Tooltip';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import noImageClub from '../../assets/icons/noImageClub.svg'
import noImagePlayer from '../../assets/icons/noImagePlayer.svg'
import noImageFlag from '../../assets/icons/noImageFlag.svg'
import { useAuth } from '../../contexts/AuthContext';
import PWNotification from '../PWNotification';
import { addUpdateClubSortListData } from './addOrUpdateClubSortlist';
import { useClubSearch } from '../../contexts/ClubSearchContext';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import RemoveIcon from '../../assets/icons/remove.png'
import ClubIcon from '../../assets/icons/ClubIcon.svg'
import { formatNumberToKAndM, formatNumberToKAndMwithoutsign } from "../../utils/formatNumberToKandM";
import { getLeaguePositionDetails } from '../../utils/clubFormationsFunctions';
import InfoIcon from '../../assets/icons/infoicon.svg'
import YellowCardSvg from "../../assets/event_icons/Yellow_card.png";
import RedCardSvg from "../../assets/event_icons/red_card.png";
import PrimaryButton from '../../ui/PrimaryButton';
import GoldStar from "../../assets/icons/GoldStar.png";
import { TeamArchetypeInfoDrawer } from '../../pages/Chemistry/UIContent';

interface tableDataProps {
  tableData: IClubComparisonData[] | undefined;
  isFromSortList?: boolean;
  selectedSeasonName?: string
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
      backgroundColor: '#F2F5EE',
      border: 'none',
  },
}));

const ClubComparisonTableContent: React.FC<tableDataProps> = ({ tableData , isFromSortList , selectedSeasonName }) => {

    const { startLoading, stopLoading, loading } = useLoading();
    const navigate = useNavigate();
    const { userData } = useAuth();
    const {addedPlayers , setAddedPlayers } = useClubSearch();
        
    const [filterSortData, setFilterSortData] = useState<IClubComparisonData[]>([]);
    const [isAscending, setIsAscending] = useState<boolean>(false);
    const [sortKey, setSortKey] = useState<clubSortableKeys>("teamTotalRevenue");
    const [selectedClubIds, setSelectedClubIds] = useState<number[]>([]);
    const [isRemoveClub , setIsRemoveClub] = useState<boolean>(false)
    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false)
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);
    const [menuOpenClubId, setMenuOpenClubId] = useState<number | null>(null);
    const [teamsidebarOpen, setTeamSidebarOpen] = useState<boolean>(false);
    const [activeformation , setActiveFormation] = useState<string>("")
    const [activeArcheTypeId, setActiveArcheTypeId] = useState<number>(0);
    const [activeArcheTypeName, setActiveArcheTypeName] = useState<string>("");
    
    const [addedPlayerShortList, setAddedClubShortList] = useState<boolean>(false);
      const [expandedSections, setExpandedSections] = useState({
        finalThird: false,
        buildUpPlay: false,
        defense: false,
      });
    
    const toggleExpand = (section: keyof typeof expandedSections) => {
        setExpandedSections((prev) => ({
        ...prev,
        [section]: !prev[section],
        }));
    };
    const allSelected = selectedClubIds.length === filterSortData.length;
    const noneSelected = selectedClubIds.length === 0;
    let environment = process.env.REACT_APP_MODE ?? "";
    
    const getNestedValue = (obj: any, path: string) => {
      return path.split('.').reduce((acc, part) => {
          if (acc) {
              // Check if part includes array notation
              const match = part.match(/(\w+)\[(\d+)\]/);
              if (match) {
                  const [, arrayProp, index] = match;
                  return acc[arrayProp] && acc[arrayProp][index];
              }
              return acc[part];
          }
          return undefined;
      }, obj);
    };

    useEffect(() => {
        if (tableData?.length! === 0) return;

        let processedData = [...tableData!];

        processedData.sort((a, b) => {
            const aValue = getNestedValue(a, 'teamTotalRevenue');
            const bValue = getNestedValue(b, 'teamTotalRevenue');
            return bValue - aValue;
        });
        setFilterSortData(processedData);
    }, [tableData]);
  
    const handleSortClick = (key: clubSortableKeys) => {
        startLoading();
        const ascending = sortKey === key ? !isAscending : true; // Toggle sort order if the same column is clicked
        setIsAscending(ascending);
        setSortKey(key);

        const sortedData = [...filterSortData].sort((a, b) => {
            const aValue = getNestedValue(a, key);
            const bValue = getNestedValue(b, key);
            if (aValue === undefined || bValue === undefined) {
                return 0;
            }

            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            }

            return ascending ? aValue - bValue : bValue - aValue;
        });
        setFilterSortData(sortedData);
        setTimeout(() => {
            stopLoading();
        }, 200);
    };

        // Handle checkbox change - toggle the playerId in the array
        const handleCheckboxChange = (clubId: number) => {
          setSelectedClubIds((prevState) =>
              prevState.includes(clubId)
                  ? prevState.filter((id) => id !== clubId)  // Remove playerId if already selected
                  : [...prevState, clubId]  // Add playerId if not selected
          );
      };
  
      // Handle select all
      const handleSelectAll = () => {
          const allPlayerIds = filterSortData.map(club => club?.teamId);
          setSelectedClubIds(prevSelectedPlayerIds => [
              ...prevSelectedPlayerIds,
              // ...(benchmarkRecord?.playerId != null ? [benchmarkRecord.playerId] : []),
              ...allPlayerIds
          ]);
  
          // setSelectedPlayerIds(allPlayerIds)
      };
  
  
      // Handle deselect all
      const handleDeselectAll = () => {
        setSelectedClubIds([]);
      };

      const getBgColor = (value : number) => {
        if (value > 0) {
          return '#C9F0B5';  // Positive values -> Green background
        } else if (value < 0) {
          return '#FFC2C2';    // Negative values -> Red background
        } else {
          return '#DADADA';   // Neutral (zero) case
        }
      };


      const handleActions = (teamId? : number) =>{
          if(selectedClubIds.length > 0 && isFromSortList){
              addUpdateClubSortListData(
                  userData,
                  selectedClubIds!,
                  startLoading,
                  stopLoading,
                  setDisplayCustomNotification,
                  setCustomNotificationContent,
                  false,
                  navigate
      
              );
              setFilterSortData((prevData:any) => {
                  // Find all players that are in selectedPlayerIds but not in prevData
                  const playersToAdd = selectedClubIds
                    .filter(
                      (teamId) => !prevData.some((club:any) => club?.teamId === teamId)
                    )
                    .map((teamId) => tableData?.find((club) => club?.teamId === teamId))
                    .filter((club) => club); // Filter out any undefined results
              
                  // Merge the new players with the previous data
                  return [...prevData, ...playersToAdd];
                });
      
          }
          else{
              setAddedPlayers((prevAddedPlayers: any) => {
                  const isCurrentlyInShortlist = prevAddedPlayers[teamId!];
                  const updatedAddedPlayers = {
                      ...prevAddedPlayers,
                      [teamId!]: !isCurrentlyInShortlist, // Toggle the shortlist status
                  };
                   return updatedAddedPlayers;
              });
         
              addUpdateClubSortListData(
                  userData,
                  [teamId!],
                  startLoading,
                  stopLoading,
                  setDisplayCustomNotification,
                  setCustomNotificationContent,
                  false,
                  navigate
      
              );
      
              if (isFromSortList) {
                  setFilterSortData((prevData) => {
                    // Check if the player is already in prevData
                    const playerExists = prevData.some((club) => club?.teamId === teamId);
                    
                    // If the player doesn't exist, add it; otherwise, leave prevData unchanged
                    if (!playerExists) {
                      const playerToAdd = tableData?.find((club) => club?.teamId === teamId);
                      return playerToAdd ? [...prevData, playerToAdd] : prevData;
                    }
              
                    return prevData;
                  });
                }
          }
                  
              // setFilterSortData(tableData);
              // setSelectedPlayerIds([])
              // setSortKey('')
          }


      //handle multiple remove players 
    //------------------------------------
    const handleRemovePlayer = () => {
      // Add selectedPlayerIds to local storage
      //localStorage.setItem('removedPlayerIds', JSON.stringify(selectedPlayerIds));
      setIsRemoveClub(true)
      // setISundoPlayerIds(selectedPlayerIds)
      let storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem('removedclubIds') || '[]');
      if (storedRemovePlayerIds && storedRemovePlayerIds.length > 0) {
              //const combinedArray: number[] = storedRemovePlayerIds.concat(selectedPlayerIds).filter((value, index, self) => self.indexOf(value) === index);
              //setSelectedPlayerIds(selectedPlayerIds.filter((num:number) => !storedRemovePlayerIds.includes(num))); // Remove duplicates
              const combinedArray: number[] = storedRemovePlayerIds.concat(selectedClubIds).filter((value, index, self) => self.indexOf(value) === index);
              setSelectedClubIds(combinedArray);
              storedRemovePlayerIds = storedRemovePlayerIds.concat(selectedClubIds); // Add the unique numbers
              localStorage.setItem('removedclubIds', JSON.stringify(storedRemovePlayerIds));
      }
      else {
              localStorage.setItem('removedclubIds', JSON.stringify(selectedClubIds));
      }

      addUpdateClubSortListData(
          userData,
          selectedClubIds,
          startLoading,
          stopLoading,
          setDisplayCustomNotification,
          setCustomNotificationContent,
          true,
          navigate
      );
      setFilterSortData((prevData) => prevData.filter(club => !selectedClubIds.includes(club?.teamId)));
      setCustomNotificationContent(
          <div className="notification">
              <p className="sortlist-notofication-content">
                  <BookmarkBorderOutlinedIcon className="icon" />
                  <LabelText className="squad-chart-tooltip notification-content">Clubs removed from your shortlist </LabelText>
                  <LabelText className="player-given-name notification-content" style={{cursor:'pointer'}} 
                  onClick={() => handleActions()}>Undo</LabelText>
              </p>
          </div>
      );
      setSelectedClubIds([]);
  }


  const handleSingleRemove = (clubId: number) => {
    // Add playerId to local storage
    //localStorage.setItem('removedPlayerIds', JSON.stringify([playerId]));
    setIsRemoveClub(true)
    // setISundoPlayerIds([playerId])
    let storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem('removedIds') || '[]');
    if (storedRemovePlayerIds && storedRemovePlayerIds.length > 0) {
        if (!storedRemovePlayerIds.includes(clubId)) {
            storedRemovePlayerIds.push(clubId); // Add only if it's not a duplicate
        }
        localStorage.setItem('removedclubIds', JSON.stringify(storedRemovePlayerIds));
    }
    else {
        localStorage.setItem('removedclubIds', JSON.stringify([clubId]));
    }

    addUpdateClubSortListData(
        userData,
        [clubId],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        true,
        navigate
    );
    setFilterSortData((prevData) => prevData.filter(club => club?.teamId !== clubId));
    setCustomNotificationContent(
        <div className="notification">
            <p className="sortlist-notofication-content">
                <BookmarkBorderOutlinedIcon className="icon" />
                <LabelText className="squad-chart-tooltip notification-content">Player removed from your shortlist </LabelText>
                <LabelText className="player-given-name notification-content" style={{cursor:'pointer'}} 
                onClick={() => handleActions(clubId)}>Undo</LabelText>
            </p>
        </div>
    );
}

    const handleMenuOpen = (clubId: number) => {
    setMenuOpenClubId((prevId) => (prevId === clubId ? null : clubId));
    };


  const renderMenuCard = (clubId: number) => {
        return (
            <>
                <div className='menu-card-container'>
                    <div className='menu-list-container'>
                        <LabelNumber className='attack-defense-data'>OPTIONS</LabelNumber>
                    </div>
                    {isFromSortList && (
                        <div className='menu-list-container' onClick={() => handleSingleRemove(clubId)}>
                            <img src={RemoveIcon} height={24} width={24} /> <LabelText className='remove-sortlist-text'>Remove from shortlist</LabelText>
                        </div>
                    )}
                    <div className='menu-list-container' onClick={() => { navigate(`/club/${clubId}`) }}>
                        <img src={ClubIcon} height={24} width={24} style={{color:'black'}}/><LabelText className='menu-list'>Club Profile</LabelText>
                    </div>
                </div>
            </>
        )
    }

    const handleAddorUpdateClubSortList = async () => {
        //object state for which players are added
        setAddedPlayers((prevAddedPlayers: any) => {
            const updatedPlayers = { ...prevAddedPlayers };
            selectedClubIds.forEach((playerId: number) => {
            updatedPlayers[playerId] = !prevAddedPlayers[playerId]; // Toggle the boolean value
            });
            return updatedPlayers;
        });
        setAddedClubShortList(true)
        await addUpdateClubSortListData(
            userData,
            selectedClubIds,
            startLoading,
            stopLoading,
            setDisplayCustomNotification,
            setCustomNotificationContent,
            false,
            navigate

        );
        setSelectedClubIds([]);
        setCustomNotificationContent(
            <div className="notification">
                <p className="sortlist-notofication-content">
                    <BookmarkBorderOutlinedIcon className="icon" />
                    <LabelText className="squad-chart-tooltip notification-content">Players added to your shortlist</LabelText>
                    <LabelText className="player-given-name notification-content" style={{cursor:'pointer'}} 
                    onClick={() => navigate('/shortlists')}>View shortlist</LabelText>
                
                </p>
            </div>
        );

    };

    const getBackgroundSystemfitColor = (usagePercentage: number) => {
        if (usagePercentage >= 0 && usagePercentage <= 19) return "#FF3864";
        if (usagePercentage >= 20 && usagePercentage <= 39) return "#FF7800";
        if (usagePercentage >= 40 && usagePercentage <= 59) return "#F2E94E";
        if (usagePercentage >= 60 && usagePercentage <= 100) return "#4AF075";
        return "transparent"; // Default color if usagePercentage is out of range
    };

    // const { formattedPosition, formattedDifference, differenceColor, tooltipText } = getLeaguePositionDetails(filterSortData!);

const exportToCsv = () => {
    const headers = [
        'Club',
        'Nationality',
        'League',
        'Archetype',
        'PPG',
        'XG Per 90',
        'XG Against Per 90',
        'League Position',
        'Expected League Position',
        'Revenue',
        'Costs',
        'Profit/Loss',
        'Final Third',
        'Finishing - Shots',
        'Finishing - Aerial',
        'Attack Positioning',
        'Build-Up Play',
        'Creativity',
        'Passing Accuracy',
        'Dribbling',
        'Crossing',
        'Defence',
        'Tackling',
        'Defensive Headers',
        'Ball Recovery',
        'Debt',
        'Intangible Assets',
        'Player receivables - total',
        'Player receivables - due within 12 m',
        'Av. System fit',
        'Av. Player age',
        'Av. Player value',
        'Av. wage pw',
        'Bookings this season- YellowCard',
        'Bookings this season- RedCard'
    ];

    const rows = filterSortData.map((club) => {
        const leaguePosition =
        club.currentLeaguePosition && club.currentLeaguePosition !== 0
            ? `${club.currentLeaguePosition}`
            : club.currentExpectedLeaguePosition && club.currentExpectedLeaguePosition !== 0
            ? `${club.currentExpectedLeaguePosition}`
            : '--';

        return [
            club?.teamLabel || '--',
            club?.teamNationalityName || '--',
            club?.competitionName || '--',
            club?.archetypes?.archetypeName! || '--',
            club?.archetypes?.ppg?.toFixed(2)! || '--',
            club?.totalXgShot! || '--',
            club?.totalXgShotAgainst! || '--',
            leaguePosition,
            club?.currentExpectedLeaguePosition && club?.currentExpectedLeaguePosition !== 0 
                ? `${club?.currentExpectedLeaguePosition}`
                : '--',
            club?.teamTotalRevenueText !== '0' ? `€${club?.teamTotalRevenueText}` : '--',
            club?.teamTotalCostsText !== '0' ? `€${club?.teamTotalCostsText}` : '--',
            club?.teamTotalProfitLossText !== '0' ? `€${club?.teamTotalProfitLossText}` : '--',
            club?.teamFinalThird?.finalScore === 100 ? '99.99' : club?.teamFinalThird?.finalScore?.toFixed(2) || '--',
            club?.teamFinalThird?.finishingShots === 100 ? '99.99' : club?.teamFinalThird?.finishingShots?.toFixed(2) || '--',
            club?.teamFinalThird?.finishingAerial === 100 ? '99.99' : club?.teamFinalThird?.finishingAerial?.toFixed(2) || '--',
            club?.teamFinalThird?.attackPositioning === 100 ? '99.99' : club?.teamFinalThird?.attackPositioning?.toFixed(2) || '--',
            club?.teamBuildUpPlay?.finalScore === 100 ? '99.99' : club?.teamBuildUpPlay?.finalScore?.toFixed(2) || '--',
            club?.teamBuildUpPlay?.creativity === 100 ? '99.99' : club?.teamBuildUpPlay?.creativity?.toFixed(2) || '--',
            club?.teamBuildUpPlay?.passingAccuracy === 100 ? '99.99' : club?.teamBuildUpPlay?.passingAccuracy?.toFixed(2) || '--',
            club?.teamBuildUpPlay?.dribbling === 100 ? '99.99' : club?.teamBuildUpPlay?.dribbling?.toFixed(2) || '--',
            club?.teamBuildUpPlay?.crossing === 100 ? '99.99' : club?.teamDefence?.finalScore?.toFixed(2) || '--',
            club?.teamDefence?.finalScore === 100 ? '99.99' : club?.teamDefence?.finalScore?.toFixed(2) || '--',
            club?.teamDefence?.tackling === 100 ? '99.99' : club?.teamDefence?.tackling?.toFixed(2) || '--',
            club?.teamDefence?.defensiveHeaders === 100 ? '99.99' : club?.teamDefence?.defensiveHeaders?.toFixed(2) || '--',
            club?.teamDefence?.aggression === 100 ? '99.99' : club?.teamDefence?.aggression?.toFixed(2) || '--',
            club?.teamTotalDebtText !== '0' ? `€${formatNumberToKAndM(club?.teamTotalDebt)}` : '--',
            club?.intangibleAssetsText ? `€${club?.intangibleAssetsText}` : '--',
            club?.totalReceivablesText ? `€${club?.totalReceivablesText}` : '--',
            club?.totalReceivables12MonthText ? `€${club?.totalReceivables12MonthText}` : '--',
            club?.teamAverageSystemFit ? `${club?.teamAverageSystemFit}` : '--',
            club?.teamAveragePlayerAge ? `${club?.teamAveragePlayerAge}` : '--',
            club?.teamAverageSquadValueText ? `€${club?.teamAverageSquadValueText}` : '--',
            club?.avWagePerWeekText ? `€${club?.avWagePerWeekText}` : '--',
            club?.yellowCards ? club?.yellowCards : '--',
            club?.redCards ? club?.redCards : '--'
        ];
    });

    // Add BOM for proper UTF-8 encoding (includes € symbol)
    const csvContent = '\uFEFF' + [
        headers.join(','),
        ...rows.map(row => row.map(value => `"${value}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `Club_shortlist_${selectedSeasonName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  const getBackgroundColor = (performanceValue?: number, universal?: boolean) => {
    // if (performanceValue! == null) {
    //   return "none";
    // }
    if (performanceValue! > 0 && performanceValue! <= 24.99) {
      return "var(--UI-red-500, #FF3864)";
    } else if (performanceValue! >= 25 && performanceValue! <= 49.99) {
      return "var(--Brand-orange-500, #FF7800)";
    } else if (performanceValue! >= 50 && performanceValue! <= 74.99) {
      return "var(--UI-yellow-500, #F2E94E)";
    } else if (performanceValue! >= 75 && performanceValue! <= 87.99) {
      return "#C9F0B6";
    } else if (performanceValue! >= 88 && performanceValue! <= 98.99) {
      return "var(--Brand-green-2-500, #4AF075)";
    } else if (performanceValue! >= 99) {
      return "#00D1A8";
    } else if (performanceValue! === 0 || performanceValue === null) {
      return "#DADADA";
    }
    else {
      return "red";
    }
  };

  const getTextColor = (score: number) => {
    if (score > 49) {
      return "var(--UI-black-500, #000000)";
    } else {
      return "var(--UI-white-500, #FFFFFF)";
    }
  };

  const hanldeInfoClick = (archId: number,archName : string) => {
      setTeamSidebarOpen(true)
      setActiveArcheTypeId(archId);
      setActiveArcheTypeName(archName)

  };



    return (
      <>
          {loading && <LoadingSpinner />}
          <div
              // className='table-scroll min-height-table' 
              className={filterSortData.length > 3 ? 'table-scroll' : 'table-scroll min-height-table'}
          >

              <TableContainer component={Paper} className='custom-table-test' sx={{width:'fit-content'}}>

                  <Table className='custom-table'>
                      <TableHead className='custom-table-sticky'>
                          <TableRow>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamLabel')}>Club</LabelText>
                                      {sortKey === 'teamLabel' && (
                                          <img
                                              src={sortKey === 'teamLabel' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamLabel')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamNationalityName')}>Nat.</LabelText>
                                      {sortKey === 'teamNationalityName' && (
                                          <img
                                              src={sortKey === 'teamNationalityName' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamNationalityName')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('competitionName')}>League</LabelText>
                                      {sortKey === 'competitionName' && (
                                          <img
                                              src={sortKey === 'competitionName' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('competitionName')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                <div className="custon-align">
                                  <LabelText className="comparison-table-header" onClick={() => handleSortClick("archetypes.archetypeName")}>
                                    Archetype
                                  </LabelText>
                                  {sortKey === "archetypes.archetypeName" && (
                                    <img
                                      src={sortKey === "archetypes.archetypeName" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                      onClick={() => handleSortClick("archetypes.archetypeName")}
                                      className="sort-img"
                                    />
                                  )}
                                </div>
                              </TableCell>
                               <TableCell>
                                <div className="custon-align">
                                  <LabelText className="comparison-table-header" onClick={() => handleSortClick("archetypes.ppg")}>
                                    PPG
                                  </LabelText>
                                  {sortKey === "archetypes.ppg" && (
                                    <img
                                      src={sortKey === "archetypes.ppg" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                      onClick={() => handleSortClick("archetypes.ppg")}
                                      className="sort-img"
                                    />
                                  )}
                                </div>
                              </TableCell>
                                <TableCell>
                                <div className="custon-align">
                                  <LabelText className="comparison-table-header" onClick={() => handleSortClick("totalXgShot")}>
                                    XG Per 90
                                  </LabelText>
                                  {sortKey === "totalXgShot" && (
                                    <img
                                      src={sortKey === "totalXgShot" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                      onClick={() => handleSortClick("totalXgShot")}
                                      className="sort-img"
                                    />
                                  )}
                                </div>
                              </TableCell>
                                <TableCell>
                                <div className="custon-align">
                                  <LabelText className="comparison-table-header" onClick={() => handleSortClick("totalXgShotAgainst")}>
                                    XG Against Per 90
                                  </LabelText>
                                  {sortKey === "totalXgShotAgainst" && (
                                    <img
                                      src={sortKey === "totalXgShotAgainst" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                      onClick={() => handleSortClick("totalXgShotAgainst")}
                                      className="sort-img"
                                    />
                                  )}
                                </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('currentLeaguePosition')}>League Pos.</LabelText>
                                      {sortKey === 'currentLeaguePosition' && (
                                          <img
                                              src={sortKey === 'currentLeaguePosition' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('currentLeaguePosition')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamTotalRevenue')}>Revenue</LabelText>
                                      {sortKey === 'teamTotalRevenue' && (
                                          <img
                                              src={sortKey === 'teamTotalRevenue' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamTotalRevenue')}
                                              className="sort-img"
                                          />
                                      )}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamTotalCosts')}>Costs</LabelText>
                                      {sortKey === 'teamTotalCosts' && (
                                          <img
                                              src={sortKey === 'teamTotalCosts' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamTotalCosts')}
                                              className="sort-img"
                                          />
                                      )}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamTotalProfitLoss')}>Profit/loss</LabelText>
                                      {sortKey === 'teamTotalProfitLoss' && (
                                          <img
                                              src={sortKey === 'teamTotalProfitLoss' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamTotalProfitLoss')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell className={`sub-header sub-header-head ${expandedSections.finalThird ? "expand" : ""}`}>
                                                <div className="attribute-score-header">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      className="comparison-table-header"
                                                      onClick={() =>
                                                        handleSortClick("teamFinalThird.finalScoreZscore")
                                                      }
                                                    >
                                                      Final Third
                                                    </LabelText>
                                                    {sortKey ==="teamFinalThird.finalScoreZscore" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamFinalThird.finalScoreZscore" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamFinalThird.finalScoreZscore")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <SecondaryButton
                                                    iconType={expandedSections.finalThird ? "keyboardarrowleft" : "keyboardarrowright"}
                                                    onClick={() => toggleExpand("finalThird")}
                                                    className="column-expand-btn"
                                                  />
                                                </div>
                              
                                                <div className="test">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamFinalThird.finishingShotsZScores")
                                                      }
                                                    >
                                                      Finishing - Shots
                                                    </LabelText>
                                                    {sortKey ==="teamFinalThird.finishingShotsZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamFinalThird.finishingShotsZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamFinalThird.finishingShotsZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamFinalThird.finishingAerialZScores")
                                                      }
                                                    >
                                                      Finishing - Aerial
                                                    </LabelText>
                                                    {sortKey === "teamFinalThird.finishingAerialZScores" && (
                                                      <img
                                                        src={
                                                          sortKey === "teamFinalThird.finishingAerialZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamFinalThird.finishingAerialZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamFinalThird.attackPositioningZScores")
                                                      }
                                                    >
                                                      Atk. Positioning
                                                    </LabelText>
                                                    {sortKey ==="teamFinalThird.attackPositioningZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamFinalThird.attackPositioningZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick( "teamFinalThird.attackPositioningZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                </div>
                                              </TableCell>
                              
                                              <TableCell className={`sub-header sub-header-head ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                                                <div className="attribute-score-header">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      className="comparison-table-header"
                                                      onClick={() =>
                                                        handleSortClick("teamBuildUpPlay.finalScoreZscore")
                                                      }
                                                    >
                                                      Build Up Play
                                                    </LabelText>
                                                    {sortKey ==="teamBuildUpPlay.finalScoreZscore" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamBuildUpPlay.finalScoreZscore" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamBuildUpPlay.finalScoreZscore")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <SecondaryButton
                                                    iconType={expandedSections.buildUpPlay ? "keyboardarrowleft" : "keyboardarrowright"}
                                                    onClick={() => toggleExpand("buildUpPlay")}
                                                    className="column-expand-btn"
                                                  />
                                                </div>
                                                <div className="test">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamBuildUpPlay.creativityZScores")
                                                      }
                                                    >
                                                      Creativity
                                                    </LabelText>
                                                    {sortKey ==="teamBuildUpPlay.creativityZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamBuildUpPlay.creativityZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamBuildUpPlay.creativityZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                              
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamBuildUpPlay.passingAccuracyZScores")
                                                      }
                                                    >
                                                      Passing accuracy
                                                    </LabelText>
                                                    {sortKey ==="teamBuildUpPlay.passingAccuracyZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamBuildUpPlay.passingAccuracyZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamBuildUpPlay.passingAccuracyZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamBuildUpPlay.dribblingZScores")
                                                      }
                                                    >
                                                      Dribbling
                                                    </LabelText>
                                                    {sortKey ==="teamBuildUpPlay.dribblingZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamBuildUpPlay.dribblingZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamBuildUpPlay.dribblingZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamBuildUpPlay.crossingZScores")
                                                      }
                                                    >
                                                      Crossing
                                                    </LabelText>
                                                    {sortKey ==="teamBuildUpPlay.crossingZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamBuildUpPlay.crossingZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamBuildUpPlay.crossingZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                </div>
                                              </TableCell>
                                              <TableCell className={`sub-header sub-header-head ${expandedSections.defense ? "expand" : ""}`}>
                                                <div className="attribute-score-header">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      className="comparison-table-header"
                                                      onClick={() =>
                                                        handleSortClick("teamDefence.finalScoreZscore")
                                                      }
                                                    >
                                                      Defense
                                                    </LabelText>
                                                    {sortKey ==="teamDefence.finalScoreZscore" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamDefence.finalScoreZscore" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamDefence.finalScoreZscore")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <SecondaryButton
                                                    iconType={expandedSections.defense ? "keyboardarrowleft" : "keyboardarrowright"}
                                                    onClick={() => toggleExpand("defense")}
                                                    className="column-expand-btn"
                                                  />
                                                </div>
                              
                                                <div className="test">
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamDefence.tacklingZScores")
                                                      }
                                                    >
                                                      Tackling
                                                    </LabelText>
                                                    {sortKey ==="teamDefence.tacklingZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamDefence.tacklingZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamDefence.tacklingZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamDefence.defensiveHeadersZScores")
                                                      }
                                                    >
                                                      Def. headers
                                                    </LabelText>
                                                    {sortKey ==="teamDefence.defensiveHeadersZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamDefence.defensiveHeadersZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamDefence.defensiveHeadersZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="custon-align">
                                                    <LabelText
                                                      onClick={() =>
                                                        handleSortClick("teamDefence.aggressionZScores")
                                                      }
                                                    >
                                                      Ball Recovery
                                                    </LabelText>
                                                    {sortKey ==="teamDefence.aggressionZScores" && (
                                                      <img
                                                        src={
                                                          sortKey ==="teamDefence.aggressionZScores" && isAscending
                                                            ? SortArrowAscIcon
                                                            : SortArrowDescIcon
                                                        }
                                                        onClick={() =>
                                                          handleSortClick("teamDefence.aggressionZScores")
                                                        }
                                                        className="sort-img"
                                                      />
                                                    )}
                                                  </div>
                                                </div>
                                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamTotalDebt')}>Debt</LabelText>
                                      {sortKey === 'teamTotalDebt' && (
                                          <img
                                              src={sortKey === 'teamTotalDebt' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamTotalDebt')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('intangibleAssets')}>Intangible assets</LabelText>
                                      {sortKey === 'intangibleAssets' && (
                                          <img
                                              src={sortKey === 'intangibleAssets' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('intangibleAssets')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('totalReceivables')}>Player receivables - total</LabelText>
                                      {sortKey === 'totalReceivables' && (
                                          <img
                                              src={sortKey === 'totalReceivables' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('totalReceivables')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('totalReceivables12Month')}>Player receivables - due within 12 m</LabelText>
                                      {sortKey === 'totalReceivables12Month' && (
                                          <img
                                              src={sortKey === 'totalReceivables12Month' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('totalReceivables12Month')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              {/* <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamAssetsLiabilities')}>Assets/liabilities</LabelText>
                                      {sortKey === 'teamAssetsLiabilities' && (
                                          <img
                                              src={sortKey === 'teamAssetsLiabilities' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamAssetsLiabilities')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell> */}
                              {/* <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamTradingEfficiency')}>Trading efficiency</LabelText>
                                      {sortKey === 'teamTradingEfficiency' && (
                                          <img
                                              src={sortKey === 'teamTradingEfficiency' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamTradingEfficiency')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>*/}
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamAverageSystemFit')}>Av. System fit</LabelText>
                                      {sortKey === 'teamAverageSystemFit' && (
                                          <img
                                              src={sortKey === 'teamAverageSystemFit' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamAverageSystemFit')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              {/*<TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamAverageSquadForm')}>Av. Squad form</LabelText>
                                      {sortKey === 'teamAverageSquadForm' && (
                                          <img
                                              src={sortKey === 'teamAverageSquadForm' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamAverageSquadForm')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell> */}

                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamAveragePlayerAge')}>Av. Player age</LabelText>
                                      {sortKey === 'teamAveragePlayerAge' && (
                                          <img
                                              src={sortKey === 'teamAveragePlayerAge' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamAveragePlayerAge')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('teamAverageSquadValue')}>Av. Player value</LabelText>
                                      {sortKey === 'teamAverageSquadValue' && (
                                          <img
                                              src={sortKey === 'teamAverageSquadValue' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('teamAverageSquadValue')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header' onClick={() => handleSortClick('avWagePerWeek')}>Av. wage pw</LabelText>
                                      {sortKey === 'avWagePerWeek' && (
                                          <img
                                              src={sortKey === 'avWagePerWeek' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                              onClick={() => handleSortClick('avWagePerWeek')}
                                              className="sort-img"
                                          />)}
                                  </div>
                              </TableCell>
                              <TableCell>
                                  <div className='custon-align'>
                                      <LabelText className='comparison-table-header'>Bookings this season</LabelText>
                                  </div>
                              </TableCell>
                              <TableCell className='right-table-menu-main'>
                              </TableCell>
                              {/* <TableCell>Contract Value</TableCell> */}
                          </TableRow>
                      </TableHead>

                    {tableData?.length! > 0 && (
                        <TableBody>
                            {filterSortData.map((club, index) => {
                              const { formattedPosition, formattedDifference, differenceColor, tooltipText } = getLeaguePositionDetails(club!);
                              return(
                                    <React.Fragment key={index}>
                                        {/* Main Row */}
                                        <StyledTableRow key={index} className={`player-row`}>
                                            <TableCell>
                                                <div className='player-row'>
                                                    <img
                                                        className={`player-table-image ${selectedClubIds.includes(club?.teamId) ? 'hidden' : ''}`}
                                                        style={{
                                                            backgroundImage: `url(${club?.teamLogoURL || ''})`,
                                                        }}
                                                        src={club?.teamLogoURL ? club?.teamLogoURL : noImageClub}
                                                    />
                                                    <input type='checkbox'
                                                        checked={selectedClubIds.includes(club.teamId)}
                                                        onChange={() => handleCheckboxChange(club.teamId)}
                                                        className={`circle-checkbox  ${selectedClubIds.includes(club.teamId) ? 'visible' : ''}`}
                                                    />
                                                    <div className='player-row-details'>
                                                        <LabelText className='player-filter-labeltext' onClick={() => { navigate(`/club/${club?.teamId}`) }}>{club?.teamLabel}</LabelText>
                                                        {/* <LabelNumber className='attack-defense-data'>{player.topPosition}</LabelNumber> */}
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <CustomizedTooltips title={club?.teamNationalityName}>
                                                    <img
                                                        src={club?.teamNationalityAlpha3Code ? `/assets/country_flags/${club?.teamNationalityAlpha3Code}.svg` : noImageFlag}
                                                        alt="Country Flag"
                                                        className="player-country-image"
                                                    />
                                                </CustomizedTooltips>
                                            </TableCell>
                                            <TableCell>
                                                <div className='player-row'>
                                                    <img
                                                        height={32}
                                                        width={32}
                                                        src={club?.competitionImage ? club?.competitionImage : ''}
                                                    />
                                                    <div className='player-row-details'>
                                                        <LabelNumber className='table-age-text'>{club?.competitionName}</LabelNumber>
                                                        {/* <LabelNumber className='attack-defense-data'>{player.topPosition}</LabelNumber> */}
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell style={{textWrap:'nowrap',display:'flex',alignItems:'center',gap:'10px'}}>
                                              {club?.archetypes?.archetypeName ? (
                                                <>
                                                    <LabelNumber className="table-age-text">{club?.archetypes?.archetypeName!}</LabelNumber>
                                                    <img src={InfoIcon} height={24} width={24} onClick={() => hanldeInfoClick(club?.archetypes?.archetypeId!,club?.archetypes?.archetypeName!)}/>
                                                </>
                                              ) :(
                                                  <LabelNumber>--</LabelNumber>
                                              )}
                                              
                                            </TableCell>
                                             <TableCell style={{textWrap:'nowrap'}}>
                                              <LabelNumber className="table-age-text">{club.archetypes?.ppg?.toFixed(2)!}</LabelNumber>
                                            </TableCell>
                                            <TableCell style={{textWrap:'nowrap'}}>
                                              <LabelNumber className="table-age-text">{club?.totalXgShot!}</LabelNumber>
                                            </TableCell>
                                            <TableCell style={{textWrap:'nowrap'}}>
                                              <LabelNumber className="table-age-text">{club?.totalXgShotAgainst!}</LabelNumber>
                                            </TableCell>
                                            <TableCell>
                                            <div className='comparison-position-container'>
                                                  {club ? (
                                                      <>
                                                      {/* 1. When current position exists and is valid */}
                                                      {(club.currentLeaguePosition !== 0 && club.currentLeaguePosition !== null) ? (
                                                          <LabelNumber className='table-age-text'>
                                                          {club.currentLeaguePosition}
                                                          </LabelNumber>
                                                      ) 
                                                      // 2. If current position is missing but expected is available
                                                      : (club.currentExpectedLeaguePosition !== null && club.currentExpectedLeaguePosition !== 0) ? (
                                                          <LabelNumber className='table-age-text' >
                                                          {club.currentExpectedLeaguePosition}(exp.)
                                                          </LabelNumber>
                                                      )
                                                      // 3. If both missing (expected missing)
                                                      : (
                                                          <LabelNumber className='table-age-text'>
                                                          
                                                          </LabelNumber>
                                                      )}

                                                      {/* 4. Show difference if both exist */}
                                                      {(club.currentLeaguePosition != null && club.currentLeaguePosition !== 0) &&
                                                      (club.currentExpectedLeaguePosition != null && club.currentExpectedLeaguePosition !== 0) && (
                                                          <LabelNumber className='table-age-text' style={{ color: differenceColor }}>
                                                          {formattedDifference}
                                                          </LabelNumber>
                                                      )}

                                                      {/* 5. Expected data not available tooltip */}
                                                      {(club.currentExpectedLeaguePosition === 0 || club.currentExpectedLeaguePosition === null) && (
                                                          <CustomizedTooltips title="Expected league pos. data not available for this league">
                                                          <img src={InfoIcon} width={24} height={24} style={{marginTop:'4px'}} />
                                                          </CustomizedTooltips>
                                                      )}

                                                      {/* 6. Actual data not available tooltip */}
                                                      {(club.currentLeaguePosition === 0 || club.currentLeaguePosition === null) && (
                                                          <CustomizedTooltips title="Actual league pos. data not available for this league">
                                                          <img src={InfoIcon} width={24} height={24} style={{marginTop:'4px'}} />
                                                          </CustomizedTooltips>
                                                      )}

                                                      {/* 7. Both data not available tooltip */}
                                                      {( (club.currentExpectedLeaguePosition === 0 || club.currentExpectedLeaguePosition === null) &&
                                                          (club.currentLeaguePosition === 0 || club.currentLeaguePosition === null) ) && (
                                                          <CustomizedTooltips title="Actual and Expected league pos. data not available for this league">
                                                          <img src={InfoIcon} width={24} height={24} style={{marginTop:'4px'}} />
                                                          </CustomizedTooltips>
                                                      )}

                                                      {/* 8. Tooltip for difference (only if both are valid) */}
                                                      {(club.currentLeaguePosition != null && club.currentLeaguePosition !== 0) &&
                                                      (club.currentExpectedLeaguePosition != null && club.currentExpectedLeaguePosition !== 0) && (
                                                          <CustomizedTooltips title={tooltipText}>
                                                          <img src={InfoIcon} width={24} height={24} style={{marginTop:'4px'}} />
                                                          </CustomizedTooltips>
                                                      )}
                                                      </>
                                                  ) : null}
                                              </div>
                                            </TableCell>
                                            <TableCell><LabelNumber className='table-age-text'>{club?.teamTotalRevenueText !== "0" ? `€${formatNumberToKAndM(club?.teamTotalRevenue)}` : '--'}</LabelNumber></TableCell>
                                            <TableCell><LabelNumber className='table-age-text'>{club.teamTotalCostsText !== "0" ? `€${formatNumberToKAndM(club?.teamTotalCosts)}` : '--'}</LabelNumber></TableCell>
                                            <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBgColor(club?.teamTotalProfitLoss) }}>
                                                    <LabelNumber className="player-card-value"> {club?.teamTotalProfitLossText !== "0" ? `${club?.teamTotalProfitLoss >= 0 ? '' : '-'}€${formatNumberToKAndMwithoutsign(club?.teamTotalProfitLoss)}` : '--'}</LabelNumber>
                                                </div>
                                            </TableCell>
                                            <TableCell className={`sub-header sub-header-body ${expandedSections.finalThird ? "expand" : ""}`}>
                                                                    <div className="sub-main-wrapper">
                                                                      <div
                                                                        className="score-content"
                                                                        style={{
                                                                          backgroundColor: getBackgroundColor(club?.teamFinalThird?.finalScore),
                                                                          color: getTextColor(Number(club?.teamFinalThird?.finalScore?.toFixed(2))),
                                                                        }}
                                                                      >
                                                                        {club?.teamFinalThird?.finalScore >= 1 ? (
                                                                          <>
                                                                            <LabelNumber className="player-card-value">
                                                                              {club?.teamFinalThird?.finalScore >= 99 ? (
                                                                                <span className="gold-star-shortlist-table">
                                                                                  <img src={GoldStar} alt="star-performer" />
                                                                                </span>
                                                                              ) : null}
                                                                              {club?.teamFinalThird?.finalScore === 100 ? "99.99" : club?.teamFinalThird?.finalScore?.toFixed(2)}
                                                                            </LabelNumber>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <CustomizedTooltips title="Not enough data">
                                                                              <img src={InfoIcon} height={16} width={16} />
                                                                            </CustomizedTooltips>
                                                                            <LabelNumber className="player-card-value">--</LabelNumber>
                                                                          </>
                                                                        )}
                                                                      </div>
                                                                      <div className="sub-score-container">
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamFinalThird?.finishingShots),
                                                                            color: getTextColor(Number(club?.teamFinalThird?.finishingShots?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamFinalThird?.finishingShots >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamFinalThird?.finishingShots >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamFinalThird?.finishingShots === 100 ? "99.99" : club?.teamFinalThird?.finishingShots?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamFinalThird?.finishingAerial),
                                                                            color: getTextColor(Number(club?.teamFinalThird?.finishingAerial?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamFinalThird?.finishingAerial >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamFinalThird?.finishingAerial >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamFinalThird?.finishingAerial === 100 ? "99.99" : club?.teamFinalThird?.finishingAerial?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamFinalThird?.attackPositioning),
                                                                            color: getTextColor(Number(club?.teamFinalThird?.attackPositioning?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamFinalThird?.attackPositioning >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamFinalThird?.attackPositioning >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamFinalThird?.attackPositioning === 100 ? "99.99" : club?.teamFinalThird?.attackPositioning?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </TableCell>
                                            
                                                                  <TableCell className={`sub-header sub-header-body ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                                                                    <div className="sub-main-wrapper">
                                                                      <div
                                                                        className="score-content"
                                                                        style={{
                                                                          backgroundColor: getBackgroundColor(club?.teamBuildUpPlay?.finalScore),
                                                                          color: getTextColor(Number(club?.teamBuildUpPlay?.finalScore?.toFixed(2))),
                                                                        }}
                                                                      >
                                                                        {club?.teamBuildUpPlay?.finalScore >= 1 ? (
                                                                          <>
                                                                            <LabelNumber className="player-card-value">
                                                                              {club?.teamBuildUpPlay?.finalScore >= 99 ? (
                                                                                <span className="gold-star-shortlist-table">
                                                                                  <img src={GoldStar} alt="star-performer" />
                                                                                </span>
                                                                              ) : null}
                                                                              {club?.teamBuildUpPlay?.finalScore === 100 ? "99.99" : club?.teamBuildUpPlay?.finalScore?.toFixed(2)}
                                                                            </LabelNumber>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <CustomizedTooltips title="Not enough data">
                                                                              <img src={InfoIcon} height={16} width={16} />
                                                                            </CustomizedTooltips>
                                                                            <LabelNumber className="player-card-value">--</LabelNumber>
                                                                          </>
                                                                        )}
                                                                      </div>
                                                                      <div className="sub-score-container">
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamBuildUpPlay?.creativity),
                                                                            color: getTextColor(Number(club?.teamBuildUpPlay?.creativity?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamBuildUpPlay?.creativity >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamBuildUpPlay?.creativity >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamBuildUpPlay?.creativity === 100 ? "99.99" : club?.teamBuildUpPlay?.creativity?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamBuildUpPlay?.passingAccuracy),
                                                                            color: getTextColor(Number(club?.teamBuildUpPlay?.passingAccuracy?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamBuildUpPlay?.passingAccuracy >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamBuildUpPlay?.passingAccuracy >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamBuildUpPlay?.passingAccuracy === 100 ? "99.99" : club?.teamBuildUpPlay?.passingAccuracy?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamBuildUpPlay?.dribbling),
                                                                            color: getTextColor(Number(club?.teamBuildUpPlay?.dribbling?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamBuildUpPlay?.dribbling >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamBuildUpPlay?.dribbling >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamBuildUpPlay?.dribbling === 100 ? "99.99" : club?.teamBuildUpPlay?.dribbling?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamBuildUpPlay?.crossing),
                                                                            color: getTextColor(Number(club?.teamBuildUpPlay?.crossing?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamBuildUpPlay?.crossing >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamBuildUpPlay?.crossing >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamBuildUpPlay?.crossing === 100 ? "99.99" : club?.teamBuildUpPlay?.crossing?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </TableCell>
                                                                  <TableCell className={`sub-header sub-header-body ${expandedSections.defense ? "expand" : ""}`}>
                                                                    <div className="sub-main-wrapper">
                                                                      <div
                                                                        className="score-content"
                                                                        style={{
                                                                          backgroundColor: getBackgroundColor(club?.teamDefence?.finalScore),
                                                                          color: getTextColor(Number(club?.teamDefence?.finalScore?.toFixed(2))),
                                                                        }}
                                                                      >
                                                                        {club?.teamDefence?.finalScore >= 1 ? (
                                                                          <>
                                                                            <LabelNumber className="player-card-value">
                                                                              {club?.teamDefence?.finalScore >= 99 ? (
                                                                                <span className="gold-star-shortlist-table">
                                                                                  <img src={GoldStar} alt="star-performer" />
                                                                                </span>
                                                                              ) : null}
                                                                              {club?.teamDefence?.finalScore === 100 ? "99.99" : club?.teamDefence?.finalScore?.toFixed(2)}
                                                                            </LabelNumber>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <CustomizedTooltips title="Not enough data">
                                                                              <img src={InfoIcon} height={16} width={16} />
                                                                            </CustomizedTooltips>
                                                                            <LabelNumber className="player-card-value">--</LabelNumber>
                                                                          </>
                                                                        )}
                                                                      </div>
                                                                      <div className="sub-score-container">
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamDefence?.tackling),
                                                                            color: getTextColor(Number(club?.teamDefence?.tackling?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamDefence?.tackling >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamDefence?.tackling >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamDefence?.tackling === 100 ? "99.99" : club?.teamDefence?.tackling?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamDefence?.defensiveHeaders),
                                                                            color: getTextColor(Number(club?.teamDefence?.defensiveHeaders?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamDefence?.defensiveHeaders >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamDefence?.defensiveHeaders >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamDefence?.defensiveHeaders === 100 ? "99.99" : club?.teamDefence?.defensiveHeaders?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                        <div
                                                                          className="score-content"
                                                                          style={{
                                                                            backgroundColor: getBackgroundColor(club?.teamDefence?.aggression),
                                                                            color: getTextColor(Number(club?.teamDefence?.aggression?.toFixed(2))),
                                                                          }}
                                                                        >
                                                                          {club?.teamDefence?.aggression >= 1 ? (
                                                                            <>
                                                                              <LabelNumber className="player-card-value">
                                                                                {club?.teamDefence?.aggression >= 99 ? (
                                                                                  <span className="gold-star-shortlist-table">
                                                                                    <img src={GoldStar} alt="star-performer" />
                                                                                  </span>
                                                                                ) : null}
                                                                                {club?.teamDefence?.aggression === 100 ? "99.99" : club?.teamDefence?.aggression?.toFixed(2)}
                                                                              </LabelNumber>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <CustomizedTooltips title="Not enough data">
                                                                                <img src={InfoIcon} height={16} width={16} />
                                                                              </CustomizedTooltips>
                                                                              <LabelNumber className="player-card-value">--</LabelNumber>
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </TableCell>
                                            <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBgColor(club?.teamTotalDebt) }}>
                                                    <LabelNumber className="player-card-value"> {club?.teamTotalDebtText !== "0" ? `€${formatNumberToKAndM(club?.teamTotalDebt)}` : '--'}</LabelNumber>
                                                </div>
                                            </TableCell>
                                            <TableCell><LabelNumber className='table-age-text'>{club?.teamTotalRevenueText !== "0" ? `€${club?.intangibleAssetsText}` : '--'}</LabelNumber></TableCell>
                                            <TableCell><LabelNumber className='table-age-text'>{club?.teamTotalRevenueText !== "0" ? `€${club?.totalReceivablesText}` : '--'}</LabelNumber></TableCell>
                                            <TableCell><LabelNumber className='table-age-text'>{club?.teamTotalRevenueText !== "0" ? `€${club?.totalReceivables12MonthText}` : '--'}</LabelNumber></TableCell>

                                            {/* <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBackgroundColor(club?.teamAssetsLiabilities) }}>
                                                    <LabelNumber className="player-card-value"> {club?.teamAssetsLiabilitiesText !== "0" ? club?.teamAssetsLiabilitiesText : '--'}</LabelNumber>
                                                </div>
                                            </TableCell> */}
                                            {/* <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBackgroundColor(club?.teamTradingEfficiency) }}>
                                                    <LabelNumber className="player-card-value"> {club?.teamTradingEfficiency ? club?.teamTradingEfficiency : '--'}</LabelNumber>
                                                </div>
                                            </TableCell>*/}
                                            <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBackgroundSystemfitColor(club?.teamAverageSystemFit)}}>
                                                    <LabelNumber className="player-card-value"> {club?.teamAverageSystemFit ? club?.teamAverageSystemFit : '--'}</LabelNumber>
                                                </div>
                                            </TableCell>
                                            {/* <TableCell>
                                                <div className='score-content' style={{ backgroundColor: getBackgroundColor(club?.teamAverageSquadForm) }}>
                                                    <LabelNumber className="player-card-value"> {club?.teamAverageSquadForm ? club?.teamAverageSquadForm : '--'}</LabelNumber>
                                                </div>
                                            </TableCell> */}
                                            <TableCell>
                                                    <LabelNumber className="table-age-text"> {club?.teamAveragePlayerAge ? club?.teamAveragePlayerAge : '--'}</LabelNumber>
                                            </TableCell>
                                            <TableCell>
                                                    <LabelNumber className="table-age-text"> {club?.teamAverageSquadValueText ? `€${formatNumberToKAndM(club?.teamAverageSquadValue)}` : '--'}</LabelNumber>
                                            </TableCell>
                                            <TableCell>
                                                    <LabelNumber className="table-age-text"> {club?.teamAverageSquadValueText ? `€${club?.avWagePerWeekText}` : '--'}</LabelNumber>
                                            </TableCell>
                                            <TableCell>
                                                  <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
                                                      <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                                                          <img src={YellowCardSvg} alt="RedCardSvg" />
                                                          <LabelNumber className="table-age-text"> {club?.yellowCards ? `${club?.yellowCards}` : '--'}</LabelNumber>
                                                      </div>
                                                      <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                                                          <img src={RedCardSvg} alt="RedCardSvg" />
                                                          <LabelNumber className="table-age-text"> {club?.redCards ? `${club?.redCards}` : '--'}</LabelNumber>
                                                      </div>
                                                  </div>
                                            </TableCell>
                                            <TableCell className='right-table-menu-main'>
                                              <div className='right-table-menu'>
                                                  <SecondaryButton iconType='menu' className='column-expand-btn' 
                                                  onClick={() => handleMenuOpen(club?.teamId)} 
                                                  />
                                                  {menuOpenClubId === club?.teamId && (
                                                      <>
                                                          {renderMenuCard(club?.teamId)}
                                                      </>

                                                  )}
                                              </div>
                                          </TableCell>
                                            {/* <TableCell>{player.contractValue}</TableCell> */}

                                        </StyledTableRow>



                                        {/* Expandable Row */}
                                    </React.Fragment>
                              );
                              })}
                        </TableBody>
                    )}
                      
                     
                  </Table>

              </TableContainer>
          </div>
          <div className='table-bottom-container'>
              <div className='left-content'>
                  {noneSelected ? (
                      <SecondaryButton label="Select all" onClick={handleSelectAll} />
                  ) : allSelected ? (
                      <SecondaryButton label="Deselect all" onClick={handleDeselectAll} />
                  ) : (
                      <>
                          <SecondaryButton label="Select all" onClick={handleSelectAll} />
                          <SecondaryButton label="Deselect all" onClick={handleDeselectAll} />
                      </>
                  )}
                {filterSortData.length > 0 && (<PrimaryButton label='Export to CSV' onClick={exportToCsv}/>)} 
              </div>
              {!noneSelected && (
                  <div className='right-content'>
                      <LabelNumber className='attack-defense-data'>SELECTION OPTIONS:</LabelNumber>
                      {isFromSortList && (<SecondaryButton label="Remove" isRemoveText={true} onClick={handleRemovePlayer} />)}
                      {isFromSortList ?
                          (
                              <>
                                  {/* <SecondaryButton label="Add to another shortlist" onClick={handleAddorUpdateSortList} /> */}
                              </>
                          )
                          : (
                              <SecondaryButton label="Add to shortlist" 
                              onClick={handleAddorUpdateClubSortList} 
                              />
                          )}
                  </div>
              )}
          </div>
           <TeamArchetypeInfoDrawer
                      teamsidebarOpen={teamsidebarOpen}
                      setTeamSidebarOpen={setTeamSidebarOpen}
                      archetypeName={activeArcheTypeName}
                      activeArchetypeID={activeArcheTypeId}
                />
            {displayCustomNotification &&
            <PWNotification message={customNotificationContent} setIsNotification={() => setDisplayCustomNotification(false)}
                isDisplayCloseIcon={true}
                className='player-filter-notification add-similar-notification' />}
      </>
  )

}

export default ClubComparisonTableContent

